import React, { useContext, useState, useEffect } from "react";
import { graphql, Link, navigate, useStaticQuery } from "gatsby";
import { GatsbyImage } from "gatsby-plugin-image";
import { CartContext } from "../../../context/shopContext";
import NavLinks from "./Desktop/NavLinks";
import Sidebar from "./Mobile/Sidebar";
import DesktopSearch from "./Desktop/Search";
import { Btn2 } from "../btn";

const Navbar = () => {
  const data = useStaticQuery(graphql`
    {
      sanityMenu {
        id
        logo {
          alt
          asset {
            gatsbyImageData(
              layout: CONSTRAINED
              formats: [WEBP, AUTO]
              placeholder: BLURRED
            )
          }
        }
        navMenu {
          key: _key
          menutitle
          linkType
          slug {
            current
          }
          pdf {
            asset {
              url
            }
          }
          url
          id
        }
        button {
          buttonText
          buttonType
          buttonColor
          linkType
          slug {
            current
          }
          pdf {
            asset {
              url
            }
          }
          url
        }
      }
    }
  `);

  const { products, searchResults, setSearchResults, cart } =
    useContext(CartContext);
  const [search, setSearch] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const [quantity, setQuantity] = useState(0);

  function handleSidebar() {
    setIsOpen(!isOpen);
  }

  function handleSearch(e) {
    e.preventDefault();
    navigate(`/search?s=${encodeURIComponent(search)}`);
    setIsOpen(false);
    setSearch("");
  }

  useEffect(() => {
    if (search) {
      const results = products.filter((product) => {
        return product.title.toLowerCase()?.includes(search.toLowerCase());
      });
      setSearchResults(results);
    } else {
      setSearchResults([]);
    }
  }, [search, setSearchResults]);

  useEffect(() => {
    const totalQuantity = cart.reduce((accumulator, item) => {
      return accumulator + item.quantity;
    }, 0);

    setQuantity(totalQuantity);
  }, [cart]);

  return (
    <div className="relative w-full">
      <div className="w-full  px-4 sm:px-10 flex items-center justify-between font-dinnext bg-white">
        {/* Links */}
        <NavLinks data={data} />
        {/* Sidebar */}
        <Sidebar
          data={data}
          isOpen={isOpen}
          search={search}
          setSearch={setSearch}
          handleSearch={handleSearch}
          setIsOpen={setIsOpen}
        />
        {/* {isOpen && (
          <DesktopSearch
            search={search}
            setSearch={setSearch}
            setIsOpen={setIsOpen}
            searchResults={searchResults}
            handleSearch={handleSearch}
          />
        )} */}
        {/* Menu Bar */}
        <button
          className="block md:hidden"
          onClick={handleSidebar}
          aria-label="Open navigation menu"
          aria-expanded={isOpen}
          type="button"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-6 w-6"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth={2}
            aria-hidden="true"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M4 6h16M4 12h16M4 18h16"
            />
          </svg>
        </button>
        {/* Logo */}
        <Link
          className=""
          to="/"
          aria-label=" Simply Salad Logo"
          aria-current="page"
        >
          <GatsbyImage
            className="w-[202px] h-[72px] object-contain"
            image={data.sanityMenu.logo.asset.gatsbyImageData}
            alt={data.sanityMenu.logo.alt}
            loading="eager"
            objectFit="contain"
          />
        </Link>
        {/* Icons */}
        <div className="flex items-center md:flex-[0.4] justify-end gap-3">
          {/* <Link className="hidden sm:block" to="/">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-5 w-5 text-primary"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              strokeWidth={2}
              onClick={() => setIsOpen(true)}
              aria-label="search-icon"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
              />
            </svg>
          </Link> */}
          <div className="block">
            <Btn2
              data={data.sanityMenu.button}
              cls="min-w-[100px] sm:min-w-[167px] md:block hidden text-base sm:text-lg px-2 sm:px-4 py-0 sm:py-2 font-medium sm:font-bold"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Navbar;
